import { ReactNode } from 'react';

// For web, we don't support the keyboard overlay
export function KeyboardOverlay(props: {
  children: ReactNode;
  inputAccessoryViewID: string;
  inputFocused: boolean;
}) {
  return <></>;
}
